var map = {
	"./0xbtc.svg": 11417,
	"./1inch.svg": 49758,
	"./1st.svg": 8367,
	"./aave.svg": 22019,
	"./abbc.svg": 12655,
	"./abt.svg": 80396,
	"./ac3.svg": 62327,
	"./act.svg": 22947,
	"./ada.svg": 39380,
	"./adb.svg": 8599,
	"./adx.svg": 2973,
	"./ae.svg": 96738,
	"./aeon.svg": 51690,
	"./aergo.svg": 90298,
	"./agi.svg": 64515,
	"./aion.svg": 94037,
	"./ait.svg": 47630,
	"./akro.svg": 74721,
	"./akt.svg": 27846,
	"./aleph.svg": 9282,
	"./algo.svg": 61246,
	"./alis.svg": 74026,
	"./alpha.svg": 70604,
	"./alx.svg": 51334,
	"./amb.svg": 44691,
	"./amlt.svg": 78129,
	"./ampl.svg": 37345,
	"./anc.svg": 87464,
	"./anj.svg": 6524,
	"./ankr.svg": 75935,
	"./ant.svg": 25966,
	"./aph.svg": 2727,
	"./apl.svg": 94338,
	"./appc.svg": 11485,
	"./apy.svg": 47834,
	"./ar.svg": 74392,
	"./ardr.svg": 45559,
	"./ark.svg": 29819,
	"./arn.svg": 71462,
	"./aro.svg": 85130,
	"./arrr.svg": 63684,
	"./ast.svg": 69169,
	"./atmi.svg": 14819,
	"./atom.svg": 46245,
	"./auc.svg": 68364,
	"./aura.svg": 71356,
	"./avax.svg": 30676,
	"./awc.svg": 15277,
	"./axp.svg": 98821,
	"./bac.svg": 83500,
	"./badger.svg": 12668,
	"./bal.svg": 47145,
	"./bam.svg": 43968,
	"./band.svg": 21701,
	"./bao.svg": 20572,
	"./bat.svg": 78550,
	"./bay.svg": 45605,
	"./bbr.svg": 51337,
	"./bcd.svg": 71273,
	"./bch.svg": 38392,
	"./bcn.svg": 49055,
	"./bco.svg": 51914,
	"./bf.svg": 9183,
	"./bifi.svg": 43477,
	"./bix.svg": 6103,
	"./block.svg": 77005,
	"./blt.svg": 42921,
	"./blue.svg": 50572,
	"./blz.svg": 67770,
	"./bnb.svg": 71228,
	"./bnt.svg": 31115,
	"./bond.svg": 14110,
	"./bora.svg": 10166,
	"./box.svg": 91475,
	"./bpt.svg": 96678,
	"./bqx.svg": 10481,
	"./brd.svg": 46408,
	"./bsv.svg": 63137,
	"./btc++.svg": 45894,
	"./btc.svg": 55181,
	"./btcd.svg": 29621,
	"./btcp.svg": 1279,
	"./btg.svg": 88331,
	"./btmx.svg": 9205,
	"./bto.svg": 52894,
	"./bts.svg": 28075,
	"./btt.svg": 26283,
	"./btu.svg": 48108,
	"./bu.svg": 43507,
	"./busd.svg": 6310,
	"./bwt.svg": 64102,
	"./bz.svg": 84470,
	"./bznt.svg": 810,
	"./bzrx.svg": 7087,
	"./c20.svg": 80093,
	"./cake.svg": 27338,
	"./capp.svg": 77658,
	"./car.svg": 28874,
	"./card.svg": 66748,
	"./cbat.svg": 98727,
	"./cbc.svg": 59501,
	"./cbt.svg": 15802,
	"./cccx.svg": 6183,
	"./cdai.svg": 80938,
	"./cdt.svg": 75654,
	"./cel.svg": 94178,
	"./celr.svg": 70617,
	"./cennz.svg": 70054,
	"./ceth.svg": 31440,
	"./cfx.svg": 26013,
	"./chai.svg": 95167,
	"./chat.svg": 38313,
	"./chsb.svg": 48643,
	"./chz.svg": 47149,
	"./ckb.svg": 34475,
	"./clo.svg": 50179,
	"./cloak.svg": 42908,
	"./cmt.svg": 36698,
	"./cnd.svg": 89768,
	"./cnx.svg": 7379,
	"./comp.svg": 65306,
	"./coni.svg": 66347,
	"./cosm.svg": 8702,
	"./coti.svg": 80234,
	"./cov.svg": 53318,
	"./cova.svg": 37424,
	"./cpc.svg": 44635,
	"./cpx.svg": 97563,
	"./cre.svg": 73276,
	"./cream.svg": 83607,
	"./cred.svg": 57447,
	"./crep.svg": 79069,
	"./cro.svg": 34331,
	"./crpt.svg": 10975,
	"./crv.svg": 79252,
	"./cs.svg": 50216,
	"./csai.svg": 78087,
	"./csc.svg": 98058,
	"./ctc.svg": 84556,
	"./ctxc.svg": 74426,
	"./cube.svg": 3289,
	"./cusdc.svg": 28434,
	"./cv.svg": 74711,
	"./cvc.svg": 28358,
	"./cvt.svg": 53207,
	"./cvx.svg": 28731,
	"./cwbtc.svg": 65260,
	"./czrx.svg": 74213,
	"./dadi.svg": 88509,
	"./dag.svg": 41209,
	"./dai.svg": 92764,
	"./dasc.svg": 87602,
	"./dash.svg": 90966,
	"./dat.svg": 9762,
	"./data.svg": 59735,
	"./datx.svg": 45914,
	"./dbc.svg": 6543,
	"./dcc.svg": 64488,
	"./dcn.svg": 79306,
	"./dcr.svg": 88055,
	"./dct.svg": 3008,
	"./ddd.svg": 94748,
	"./default.svg": 54956,
	"./dent.svg": 31777,
	"./dfi.svg": 96838,
	"./dft.svg": 47803,
	"./dgb.svg": 40728,
	"./dgd.svg": 52578,
	"./dgtx.svg": 33871,
	"./divi.svg": 63490,
	"./dlt.svg": 74129,
	"./dmt.svg": 22499,
	"./dnt.svg": 80814,
	"./dock.svg": 86528,
	"./dodo.svg": 29843,
	"./doge.svg": 94077,
	"./dor.svg": 16373,
	"./dot.svg": 25761,
	"./drgn.svg": 17142,
	"./drop.svg": 88760,
	"./dta.svg": 29690,
	"./dtr.svg": 37047,
	"./dtx.svg": 75483,
	"./dxt.svg": 82319,
	"./edg.svg": 45009,
	"./edo.svg": 1655,
	"./efx.svg": 68058,
	"./egld.svg": 86353,
	"./egt.svg": 24909,
	"./ekg.svg": 79835,
	"./ekt.svg": 13175,
	"./ela.svg": 39591,
	"./elec.svg": 66281,
	"./elf.svg": 88156,
	"./emc.svg": 13894,
	"./emc2.svg": 31384,
	"./eng.svg": 20644,
	"./enj.svg": 552,
	"./eos.svg": 55316,
	"./eosdac.svg": 27375,
	"./erd.svg": 51409,
	"./ern.svg": 43281,
	"./esd.svg": 6237,
	"./esp.svg": 49076,
	"./ess.svg": 8419,
	"./etc.svg": 31026,
	"./eth.svg": 13687,
	"./etn.svg": 96326,
	"./etp.svg": 55486,
	"./etz.svg": 3159,
	"./evx.svg": 55471,
	"./ewt.svg": 47157,
	"./exrn.svg": 85846,
	"./exy.svg": 30237,
	"./fct.svg": 43736,
	"./fet.svg": 97298,
	"./fil.svg": 40069,
	"./flow.svg": 65724,
	"./fota.svg": 33358,
	"./frm.svg": 92911,
	"./fsn.svg": 71083,
	"./ft.svg": 28557,
	"./ftm.svg": 15955,
	"./ftt.svg": 89749,
	"./fuel.svg": 63628,
	"./fun.svg": 62015,
	"./fxc.svg": 5744,
	"./fxt.svg": 82340,
	"./gala.svg": 65262,
	"./gdc.svg": 58995,
	"./gem.svg": 53515,
	"./gen.svg": 15035,
	"./gno.svg": 81871,
	"./gnt.svg": 52489,
	"./gnx.svg": 10667,
	"./go.svg": 82234,
	"./goc.svg": 4407,
	"./got.svg": 31894,
	"./grin.svg": 90074,
	"./grs.svg": 54605,
	"./grt.svg": 72024,
	"./gsc.svg": 63673,
	"./gt.svg": 31527,
	"./gtc.svg": 95321,
	"./gto.svg": 88997,
	"./gusd.svg": 71485,
	"./gvt.svg": 68618,
	"./gxs.svg": 18111,
	"./hav.svg": 9696,
	"./hbar.svg": 51436,
	"./hc.svg": 46128,
	"./hedg.svg": 60405,
	"./her.svg": 28625,
	"./hex.svg": 53796,
	"./hive.svg": 60266,
	"./hot-x.svg": 83784,
	"./hot.svg": 73585,
	"./hpb.svg": 4021,
	"./hsr.svg": 61489,
	"./ht.svg": 65468,
	"./hum.svg": 26501,
	"./husd.svg": 12475,
	"./hvn.svg": 79557,
	"./hydro.svg": 74710,
	"./hyn.svg": 66039,
	"./ibat.svg": 60381,
	"./icn.svg": 58119,
	"./icx.svg": 68605,
	"./idai.svg": 31431,
	"./idex.svg": 28327,
	"./ieth.svg": 77048,
	"./ignis.svg": 82269,
	"./iknc.svg": 17066,
	"./ilink.svg": 33699,
	"./inb.svg": 33568,
	"./ins.svg": 45482,
	"./iost.svg": 35682,
	"./iota.svg": 31607,
	"./iotx.svg": 52908,
	"./iq.svg": 5667,
	"./irep.svg": 6529,
	"./iris.svg": 24609,
	"./isusd.svg": 96897,
	"./iusdc.svg": 2576,
	"./iwbtc.svg": 89015,
	"./izrx.svg": 53408,
	"./jnt.svg": 57680,
	"./jrt.svg": 50530,
	"./jst.svg": 23356,
	"./kava.svg": 44817,
	"./kcs.svg": 65009,
	"./keep.svg": 11337,
	"./key.svg": 93132,
	"./kick.svg": 26998,
	"./kin.svg": 63806,
	"./klv.svg": 37736,
	"./kmd.svg": 59776,
	"./knc.svg": 5567,
	"./ksm.svg": 4259,
	"./lamb.svg": 57671,
	"./land.svg": 65514,
	"./lba.svg": 42311,
	"./ldo.svg": 8792,
	"./lend.svg": 58674,
	"./leo.svg": 70456,
	"./link.svg": 29734,
	"./lit.svg": 48518,
	"./lky.svg": 8672,
	"./loki.svg": 34738,
	"./lon.svg": 24446,
	"./loom.svg": 6107,
	"./lpt.svg": 67300,
	"./lqd.svg": 33715,
	"./lrc.svg": 13934,
	"./lsk.svg": 14350,
	"./ltc.svg": 93890,
	"./lto.svg": 69362,
	"./lun.svg": 32092,
	"./lunc.svg": 7368,
	"./lxt.svg": 17154,
	"./lym.svg": 76653,
	"./maid.svg": 84541,
	"./man.svg": 27345,
	"./mana-old.svg": 8535,
	"./mana.svg": 32122,
	"./math.svg": 2426,
	"./matic.svg": 94691,
	"./mbc.svg": 25402,
	"./mcdai.svg": 20982,
	"./mco.svg": 43530,
	"./mcx.svg": 17441,
	"./mda.svg": 37513,
	"./mds.svg": 1513,
	"./med.svg": 69403,
	"./medx.svg": 21643,
	"./met.svg": 53149,
	"./mfg.svg": 53679,
	"./mft.svg": 94048,
	"./mir.svg": 3835,
	"./mith.svg": 83792,
	"./mkr.svg": 62324,
	"./mln.svg": 52925,
	"./mod.svg": 39726,
	"./mot.svg": 75235,
	"./mta.svg": 76591,
	"./mth.svg": 32274,
	"./mtl.svg": 94172,
	"./mtn.svg": 99946,
	"./mvc.svg": 29804,
	"./mvl.svg": 90627,
	"./mvp.svg": 93909,
	"./mwat.svg": 64964,
	"./mwc.svg": 6098,
	"./mxm.svg": 44885,
	"./myb.svg": 82600,
	"./nano.svg": 78762,
	"./nas.svg": 80855,
	"./nav.svg": 72322,
	"./ncash.svg": 5257,
	"./nct.svg": 54343,
	"./near.svg": 99698,
	"./nebl.svg": 29610,
	"./nec.svg": 54208,
	"./neo.svg": 43359,
	"./new.svg": 82934,
	"./nex.svg": 63258,
	"./nexo.svg": 64427,
	"./nexxo.svg": 37789,
	"./ngc.svg": 85659,
	"./nkn.svg": 77119,
	"./nmr.svg": 87286,
	"./noia.svg": 65776,
	"./nper.svg": 63894,
	"./npxs.svg": 52531,
	"./nrg.svg": 8625,
	"./nrve.svg": 17483,
	"./nu.svg": 17398,
	"./nuls.svg": 66520,
	"./nxs.svg": 82884,
	"./nxt.svg": 60743,
	"./oag.svg": 58142,
	"./oax.svg": 84525,
	"./ocean.svg": 98816,
	"./ocn.svg": 11335,
	"./ode.svg": 8263,
	"./ogn.svg": 55814,
	"./okb.svg": 52231,
	"./olt.svg": 1892,
	"./omg.svg": 98560,
	"./one.svg": 49925,
	"./onion.svg": 15070,
	"./ont.svg": 19575,
	"./open.svg": 46207,
	"./orbs.svg": 6175,
	"./orc.svg": 60927,
	"./orn.svg": 56333,
	"./ost.svg": 14358,
	"./ovc.svg": 92396,
	"./oxt.svg": 93160,
	"./pBTC.svg": 81292,
	"./pai.svg": 31604,
	"./pal.svg": 83926,
	"./part.svg": 49080,
	"./pax.svg": 86060,
	"./paxg.svg": 54482,
	"./pay.svg": 54854,
	"./perl.svg": 66243,
	"./pivx.svg": 17277,
	"./plDAI.svg": 87361,
	"./plUSDC.svg": 11237,
	"./play.svg": 40,
	"./plr.svg": 37732,
	"./png.svg": 73494,
	"./pnk.svg": 46849,
	"./pnt.svg": 81773,
	"./poa.svg": 23176,
	"./poe.svg": 67105,
	"./poly.svg": 78020,
	"./pond.svg": 42344,
	"./powr.svg": 93523,
	"./ppay.svg": 54992,
	"./ppc.svg": 37278,
	"./ppp.svg": 74161,
	"./ppt.svg": 29326,
	"./pre.svg": 75905,
	"./prl.svg": 33056,
	"./pro.svg": 64824,
	"./prq.svg": 55590,
	"./pst.svg": 316,
	"./qash.svg": 11168,
	"./qbit.svg": 14853,
	"./qkc.svg": 16701,
	"./qlc.svg": 94011,
	"./qnt.svg": 84357,
	"./qsp.svg": 82573,
	"./qtum.svg": 97123,
	"./r.svg": 36228,
	"./rae.svg": 88367,
	"./rari.svg": 88136,
	"./ray.svg": 99566,
	"./rcn.svg": 50259,
	"./rdd.svg": 12573,
	"./rdn.svg": 56674,
	"./ren.svg": 73886,
	"./rep.svg": 73679,
	"./req.svg": 42574,
	"./rev.svg": 73550,
	"./rfox.svg": 69005,
	"./rhoc.svg": 68112,
	"./rif.svg": 19840,
	"./rlc.svg": 40633,
	"./rose.svg": 3343,
	"./rpx.svg": 58451,
	"./rsr.svg": 23539,
	"./rsv.svg": 35037,
	"./rune.svg": 41943,
	"./rvn.svg": 78695,
	"./s.svg": 20701,
	"./sai.svg": 76738,
	"./salt.svg": 43332,
	"./san.svg": 86176,
	"./scrl.svg": 82199,
	"./scrt.svg": 63384,
	"./seele.svg": 37464,
	"./sem.svg": 74038,
	"./sfp.svg": 44446,
	"./sga.svg": 30263,
	"./sgb.svg": 79411,
	"./sgr.svg": 85368,
	"./shr.svg": 79277,
	"./shuf.svg": 73916,
	"./sia.svg": 37995,
	"./skl.svg": 95976,
	"./sky.svg": 1179,
	"./slt.svg": 40944,
	"./smart.svg": 94594,
	"./snc.svg": 38659,
	"./sngls.svg": 94480,
	"./snm.svg": 31713,
	"./snt.svg": 60853,
	"./snx.svg": 3033,
	"./sol.svg": 59030,
	"./soul.svg": 66108,
	"./spark.svg": 730,
	"./spn.svg": 56053,
	"./srm.svg": 1043,
	"./stake.svg": 89037,
	"./steem.svg": 88729,
	"./steth.svg": 48505,
	"./stmx.svg": 67106,
	"./storj.svg": 71917,
	"./storm.svg": 71545,
	"./strat.svg": 85050,
	"./stx.svg": 74666,
	"./sub.svg": 84189,
	"./super.svg": 66302,
	"./suqa.svg": 3934,
	"./sushi.svg": 54950,
	"./suter.svg": 21725,
	"./swap.svg": 41387,
	"./swth.svg": 64198,
	"./sxdt.svg": 12598,
	"./sxp.svg": 24477,
	"./sys.svg": 57801,
	"./taud.svg": 62797,
	"./tcad.svg": 29347,
	"./tct.svg": 23311,
	"./tel.svg": 53592,
	"./tfuel.svg": 88178,
	"./tgbp.svg": 44042,
	"./thc.svg": 20689,
	"./theta.svg": 88438,
	"./thkd.svg": 21213,
	"./thr.svg": 41966,
	"./tio.svg": 87845,
	"./titan.svg": 89156,
	"./tkn.svg": 45548,
	"./tky.svg": 13565,
	"./tnb.svg": 5217,
	"./tnc.svg": 37497,
	"./tnt.svg": 90915,
	"./tomo.svg": 23922,
	"./tpay.svg": 43494,
	"./trac.svg": 26227,
	"./trb.svg": 84034,
	"./trig.svg": 8160,
	"./trtl.svg": 86753,
	"./trx.svg": 90471,
	"./tryb.svg": 66370,
	"./ttc.svg": 94302,
	"./tube.svg": 86510,
	"./tusd.svg": 17925,
	"./ubq.svg": 2847,
	"./ubt.svg": 2843,
	"./ult.svg": 60459,
	"./uma.svg": 90046,
	"./unfi.svg": 85539,
	"./uni.svg": 97353,
	"./unn.svg": 14448,
	"./uos.svg": 2711,
	"./upp.svg": 86473,
	"./usd.svg": 17949,
	"./usdc.svg": 62480,
	"./usds.svg": 29356,
	"./usdt erc20.svg": 7020,
	"./usdt.svg": 99634,
	"./ust.svg": 61088,
	"./utk.svg": 66494,
	"./uuu.svg": 94012,
	"./veri.svg": 94458,
	"./vest.svg": 94816,
	"./vet.svg": 16124,
	"./via.svg": 32163,
	"./vib.svg": 87005,
	"./vibe.svg": 84868,
	"./vidt.svg": 21255,
	"./vikky.svg": 71577,
	"./vin.svg": 5875,
	"./vite.svg": 7886,
	"./viu.svg": 33076,
	"./vlx.svg": 103,
	"./vrs.svg": 35808,
	"./vsp.svg": 94331,
	"./vsys.svg": 2200,
	"./vtc.svg": 23585,
	"./wabi.svg": 39117,
	"./wan.svg": 75902,
	"./waves.svg": 29858,
	"./wbtc.svg": 39951,
	"./wct.svg": 23070,
	"./wdgld.svg": 77860,
	"./whale.svg": 66657,
	"./wib.svg": 65883,
	"./wings.svg": 41193,
	"./woo.svg": 12976,
	"./wpr.svg": 85634,
	"./wrx.svg": 91130,
	"./wtc.svg": 60271,
	"./wxt.svg": 52246,
	"./xas.svg": 99935,
	"./xaut.svg": 85121,
	"./xchf.svg": 69656,
	"./xem.svg": 30389,
	"./xin.svg": 84830,
	"./xlm.svg": 47637,
	"./xlq.svg": 46059,
	"./xmark.svg": 95756,
	"./xmr.svg": 87022,
	"./xmx.svg": 51667,
	"./xnk.svg": 90548,
	"./xns.svg": 30698,
	"./xor.svg": 4121,
	"./xrp.svg": 52978,
	"./xsn.svg": 12566,
	"./xsr.svg": 20200,
	"./xtz.svg": 70071,
	"./xvg.svg": 79339,
	"./xyo.svg": 47852,
	"./xzc.svg": 89399,
	"./yfi.svg": 42250,
	"./yoyo.svg": 54206,
	"./zai.svg": 16868,
	"./zb.svg": 55349,
	"./zco.svg": 24565,
	"./zec.svg": 52422,
	"./zel.svg": 74577,
	"./zen.svg": 90964,
	"./zil.svg": 24428,
	"./zks.svg": 14332,
	"./zrx.svg": 42773,
	"./zusd.svg": 98455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81309;